import { render, staticRenderFns } from "./edit-employee-details.vue?vue&type=template&id=24d7eb0d"
import script from "./edit-employee-details.vue?vue&type=script&lang=js"
export * from "./edit-employee-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports